import { render, staticRenderFns } from "./BillsCard.vue?vue&type=template&id=67bd29a2&scoped=true&"
import script from "./BillsCard.vue?vue&type=script&lang=js&"
export * from "./BillsCard.vue?vue&type=script&lang=js&"
import style0 from "./BillsCard.vue?vue&type=style&index=0&id=67bd29a2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bd29a2",
  null
  
)

export default component.exports